import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { assert, isDefined } from '@sama/js-core';
import { intersection } from 'lodash';
import { filter } from 'rxjs';
import { map } from 'rxjs/operators';
import { ToolsHelperService } from '../../../../../../cross-team-shared/misc-services/tools-helper.service';
import { isPointCloudOutput } from '../../../../../../cross-team-shared/misc-utils/output-utils';
import {
  isUniversalOrPointCloudTool,
  PointCloudTool,
  UniversalTool,
} from '../../../../../../cross-team-shared/tools-names';
import { getSelectedToolStore } from '../../../../../h3ml/state/task-workspace-store-utils';
import { cuboidIcon } from '../../../../../shared/icons/toolbars/cuboid-icon';
import { editIcon } from '../../../../../shared/icons/toolbars/edit-icon';
import { measureIcon } from '../../../../../shared/icons/toolbars/measure-icon';
import {
  AbstractMainToolbarComponent,
  fromSvgIcon,
} from '../abstract-main-toolbar';

export const toolButtonsBaseConfig = {
  Edit: {
    ...fromSvgIcon(editIcon),
    tooltip: 'Select',
  },
  Select: {
    ...fromSvgIcon(editIcon),
    tooltip: 'Select',
  },
  Measure: {
    ...fromSvgIcon(measureIcon),
    tooltip: 'Measure',
  },
  Cuboid: {
    ...fromSvgIcon(cuboidIcon),
    tooltip: 'Cuboid',
  },
};

@Component({
  selector: 'h3-main-point-cloud-toolbar',
  templateUrl: './main-point-cloud-toolbar.component.html',
  styleUrl: './main-point-cloud-toolbar.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class MainPointCloudToolbarComponent extends AbstractMainToolbarComponent<
  UniversalTool | PointCloudTool
> {
  protected override readonly buttonsBaseConfig = toolButtonsBaseConfig;
  private readonly toolsHelperService = inject(ToolsHelperService);
  private readonly output = this.getPointCloudOutput();

  selectedTool$ = getSelectedToolStore(
    this.taskWorkspaceStore,
    this.output.name,
  ).$.pipe(
    filter(isDefined),
    map((selectedTool) => selectedTool.name),
  );

  buttons = this.buildButtonsConfig(this.output.name);

  protected override getOrderedToolNames() {
    const toolNames = this.taskWorkspaceStore.state().readOnly
      ? ['Select', 'Measure']
      : [
          'Edit',
          ...intersection(
            ['Cuboid'],
            this.toolsHelperService.getAllowedTools(this.output.name),
          ),
          'Measure',
        ];
    return toolNames.filter(isUniversalOrPointCloudTool);
  }

  private getPointCloudOutput() {
    const { project } = this.taskWorkspaceStore.state();
    const output = project.outputs.find(isPointCloudOutput);
    assert(
      output,
      'Must have a point cloud output defined when split view is available',
    );
    return output;
  }
}
